import {DPlexArguments} from './DPlexArguments';
import {TimeoutPromise} from './promises/TimeoutPromise';

declare var DPlex:any;
declare var drupalSettings:any;
declare var JSEvents:any;
declare var Drupal:any;

type Metatags=Record<string,string>;

export class DPlexLoader {

    private dynamicDrupalSettings:string[]=['ajax','views','antibot'];
    private selector:string='.dialog-off-canvas-main-canvas';
    private uniqid:number=0;
    private isPreventPopState:boolean=false;
    private navigationid:string='';
    private lastLocation:string='';
    private lastModalLocation:string='';
    private focusMap:Record<string,WeakRef<Element>|null>={};
    private scrollPositionMap:Record<string,number>={};
    private zonesMap:Record<string,any>={};
    public static singleton:DPlexLoader;

    constructor() {
        if (DPlexLoader.singleton) return DPlexLoader.singleton;
        var container=$(this.selector).not('.leaving');
        this.lastLocation=location.pathname+location.search;
        container.on('click',(ev)=>this.click(ev));
        this.prefetchAll($(this.selector));
        //We want to bind our popstate handler first, before other
        //popstate handlers (e.g. from Drupal module 'views_ajax_history' etc.)
        //so that we can prevent their actions.
        this.bindFirst($(window),'popstate',(ev)=>this.popstate(ev));
        $(window).on("refresh",this.refresh);
        DPlexLoader.singleton=this;
        DPlex.on('ready',()=>{container.trigger("dplex.ready");});
        Drupal.behaviors.dplexLoader={attach:(context:HTMLElement|Document,settings:Record<string,unknown>)=>this.attach(context,settings)};
    }

    attach(context:Document|HTMLElement,settings:Record<string,unknown>) {
        this.prefetchAll($(context).find(this.selector).addBack(this.selector));
    }

    public prefetchAll(selector:JQuery<HTMLElement>) {
        var container=selector.not('.leaving');
        var els=container.find('a:not([rel~="noprefetch"])');
        var urls=this.getHRefs(els);
        this.prefetch(urls)
    }

    private getUUID() {
        return Math.random().toString(36).slice(2);
    }

    private getHRefs(els:JQuery):string[] {
        var urls:string[]=[];
        els.each((idx,e)=>{
            var href=this.stripHash(this.getHRef($(e)));
            if (href) urls.push(href);
        });
        return urls;
    }

    public add(selector:string) {
        var es=$(selector);
        es.off('click.dplex').on('click.dplex',(ev)=>this.click(<JQuery.ClickEvent>ev));
        var els=es.find('a');
        var urls=this.getHRefs(els);
        this.prefetch(urls);
        return this;
    }

    //Use some internal JQuery magic to move an element handler to the first position
    private bindFirst(element:JQuery<HTMLElement|Window>,name:string,fn:(ev:JQuery.TriggeredEvent)=>void) {
        element.on(name,fn);
        element.each(function() {
            var func=(<any>$)['_data'];
            var handlers=func(this,'events')[name.split('.')[0]];
            var handler=handlers.pop();
            handlers.splice(0,0,handler);
        });
    };

    private forceScrollPosition(y:number):JQuery|null {
        var scrollMax=document.documentElement.scrollHeight-document.documentElement.clientHeight;
        if (y<=scrollMax) return null;
        var sx=$('<div>');
        sx.css('position','absolute');
        sx.css('left',0);
        sx.css('top',y+document.documentElement.clientHeight);
        sx.css('width',1);
        sx.css('height',1);
        $('body').append(sx);
        return sx;
    }

    //Disables all of our events and marks the container for leaving
    public prepareLeave() {
        var leave=$(this.selector);

        if (this.lastModalLocation) {
            leave=leave.filter((idx,e)=>$(e).data("location")===this.lastModalLocation);
        }

        leave.addClass('leave leaving');
        leave.on('leave',this.leave);
        return leave;
    }

    //Bring in new HTML that will eventually replace the current page.
    private prepareEnter(html:string) {
        var existingLeaving=$(this.selector).filter('.leave');
        var leaveParent=existingLeaving.parent();
        existingLeaving.remove();
        if (leaveParent.hasClass('wrapper')) leaveParent.remove();
        var container=$(this.selector);
        var tagName=container.prop('tagName').toLowerCase();
        var enter=$('<'+tagName+'>').html(html);
        enter.attr('class',$(this.selector).attr('class')??'');
        enter[0].style.cssText=container[0].style.cssText;
        enter.removeClass('modal');
        enter.addClass('enter entering');
        enter.on('enter',(ev,args)=>this.enter(ev,args));
        enter.on('click',(ev)=>this.click(ev));
        return enter;
    }

    private async enter(ev:JQuery.TriggeredEvent,args:DPlexArguments) {
        var e=$(ev.currentTarget);
        e.removeClass('entering');
        let focus=args.metadata.enter.focus;
        if (focus && focus.length) {
            await new TimeoutPromise(1);
            focus[0].focus({preventScroll:true});
        }
    }

    private leave(ev:JQuery.TriggeredEvent,args:DPlexArguments) {
        var e=$(ev.currentTarget);
        e.remove();
        $('.loading').removeClass('loading');
    }

    private convertMetadataTree(mtree:Record<string,any>) {
        let result:Record<string,any>={};
        for (let [key,value] of Object.entries(mtree)) {
            key=key.replace(/-/g,'_');
            result[key]=value;
        }
        return result;
    }

    private convertMetadata(metadata:Record<string,any>) {
        let result:Record<string,any>={};
        for (let [stage,mtree] of Object.entries(metadata)) {
             result[stage]=this.convertMetadataTree(mtree);
         }
        return result;
    }

    private cleanNonModals() {
        let modals=$(this.selector).filter('.modal');
        if (modals.length) $(this.selector).not('.modal').parent().remove();
    }

    private saveScrollPositionAndFocus() {
        this.scrollPositionMap[this.uniqid]=document.documentElement.scrollTop;
        let activeEl=document.activeElement;
        this.focusMap[this.uniqid]=activeEl?new WeakRef(activeEl):null;
    }

    private async restoreFromState(state:any) {
        var leaveY=window.scrollY;

        this.cleanNonModals();
        if ($(this.selector).hasClass('modal')) {
            this.lastLocation=$(this.selector).data('location');
        }

        let navid=this.getUUID();
        this.navigationid=navid;

        let leaveZones=this.getZones();
        this.zonesMap[this.uniqid]=leaveZones;

        this.scrollPositionMap[this.uniqid]=document.documentElement.scrollTop;
        this.focusMap[this.uniqid]=document.activeElement?new WeakRef(document.activeElement):null;

        let enterZones=this.zonesMap[state.uniqid];

        var enter=this.prepareEnter(enterZones.html);

        let imgs=enter.find('img[src]');
        imgs.removeAttr('loading');

        let enterLocation=location.pathname+location.search;
        let md=await DPlex.metadata({leave:this.lastLocation,enter:enterLocation});

        document.title=state.title;
        this.applyMetatags(state.metatags);
        this.lastLocation=enterLocation;

        let metadata:any=this.convertMetadata(md);

        if (navid!=this.navigationid) {
            console.log('Discarding outdated navigation response.');
            return;
        }

        var leave=this.prepareLeave();

        metadata.leave={
            ...metadata.leave,
            width: leave.width(),
            height: leave.height(),
            offset: leave.offset(),
            rect: leave[0].getBoundingClientRect()
        };

        //Get scroll position of entering (previous/next) page
        if (typeof state.uniqid!="undefined" && typeof this.scrollPositionMap[state.uniqid]!="undefined") {
            metadata.enter.scrollY=this.scrollPositionMap[state.uniqid];
        } else {
            metadata.enter.scrollY=0;
        }

        let direction=(this.uniqid<state.uniqid)?"next":"prev";
        delete enterZones.html;

        let activeEl=enter.find('.history-focus');
        if (activeEl.length) {
            activeEl.removeClass('history-focus');
            metadata.enter.focus=activeEl;
        } else {
            let focusEl=this.focusMap[state.uniqid]?.deref();
            metadata.enter.focus=focusEl?$(focusEl):null;
        }

        var args:DPlexArguments=state.args??{};
        args={
            ...args,
            zones:enterZones,
            leave,
            enter,
            metadata,
            leaveY,
            direction
        };

        this.uniqid=state.uniqid;
        enter.insertAfter(leave);
        enter.removeClass('enter');
        enter.find('.autostart').removeClass('autostart');
        enter.find('[data-once]').removeAttr('data-once');
        enter.find('[data-contextual-id]').empty();

        //Find target on entering page (i.e. the element that was clicked to visit the current page)
        if (direction=='next') {
            args.target=$(this.selector).find(".history-trail");
        } else {
            args.target=enter.find(".history-trail");
        }

        let appliedSettings=this.applySettings(state.settings);
        this.scrambleIds(leave);
        Drupal.attachBehaviors(enter[0],appliedSettings);

        //Convert target-relative coordinates to page-relative coordinates
        if (args.target && args.targetX && args.targetY) {
            var rect=this.getBoundingClientRect(args.target[0]);
            args.x=args.targetX+rect.left;
            args.y=args.targetY+rect.top;
        }

        //if (typeof Drupal.displace!="undefined") Drupal.displace();
        //var sel=enter.find(this.selector).addBack(this.selector);
        $(document).trigger('nav',args);
    }

    public preventPopState() {
        this.isPreventPopState=true;
    }

    private popstate(ev:JQuery.TriggeredEvent) {
        if (this.isPreventPopState) {
            this.isPreventPopState=false;
            return;
        }
        ev.stopImmediatePropagation();
        var org=<PopStateEvent>ev.originalEvent;
        var state=org.state;
        if (!state || typeof state!=='object' || state.uniqid===undefined) return;

        let enterZones=this.zonesMap[state.uniqid];

        var url=location.pathname+location.search;
        DPlex.location(url);

        if (state.uniqid===this.uniqid) return;

        if (!enterZones) {
            DPlex.get(url,{returnOuterZones:true},
                (e:any)=>{
                    this.zonesMap[state.uniqid]=e.zones;
                    state.settings=e.settings;
                    this.restoreFromState(state);
                }
            );
        } else {
            this.restoreFromState(state);
        }

    }

    private getHRef(e:JQuery) {
        var targ=e.attr("target");
        if (e.attr("type") || (targ && targ!='_modal')) return;
        var href=e.attr("href");
        if (!href) return;
        if (href[0]!='/') return;
        if (e.parents('.contextual-links').length) return;
        if (e[0] instanceof HTMLAnchorElement) {
            if (location.pathname===e[0].pathname
                && location.search===e[0].search
                && location.hash!=e[0].hash) return;
        }
        href=href.replace(/%5B/g,'[').replace(/%5D/g,']');
        return href;
    }

    private stripHash(href:string|undefined) {
        if (!href) return href;
        var hashp=href.indexOf('#');
        if (hashp!=-1) href=href.substr(0,hashp);
        return href;
    }

    public prefetch(urls:string[]) {
        if (!urls.length) return;
        DPlex.prefetch(urls);
    }

    //Get bounding client rect even of elements that are currently not displayed
    //due to themselves or one of their parents being set to display:none by
    //temporarily setting them to display:block.
    public getBoundingClientRect(e:Element):DOMRect {
        var ep;
        ep=e;
        var arr=[];
        while (ep) {
            if (ep instanceof HTMLElement && window.getComputedStyle(ep).display=='none') {
                arr.push({element:ep,display:ep.style.display});
                ep.style.display='block';
            }
            ep=ep.parentNode;
        }
        if (!e) return new DOMRect();
        var r=e.getBoundingClientRect();
        for (var k=0;k<arr.length;k++) {
            var ai=arr[k];
            ai.element.style.display=ai.display;
        }
        return r;
    }

    private applySettings(settings:any):any {
        let appliedSettings=structuredClone(settings);
        if (!appliedSettings) appliedSettings={};
        if (!appliedSettings.dialog) appliedSettings.dialog={close:()=>{}};
        for (let key of this.dynamicDrupalSettings) {
            drupalSettings[key]=appliedSettings[key]??{};
        }
        return appliedSettings;
    }

    private getSettings():any {
        var r:any={};
        for (let key of this.dynamicDrupalSettings) {
            if (typeof drupalSettings[key]!='undefined') r[key]={...drupalSettings[key]};
        }
        return r;
    }

    private getMetatags() {
        let result:Record<string,string|null>={};
        for (let meta of ["robots","description"]) {
            let el=document.querySelector('meta[name="'+meta+'"]');
            result[meta]=el?el.getAttribute('content'):null;
        }
        return result;
    }

    private applyMetatags(metatags:Record<string,string|null>) {
        if (!metatags) return;
        for (let [name,value] of Object.entries(metatags)) {
            let el=$('meta[name='+name+']');
            if (el.length) el.remove();
            if (value) {
                $('head').prepend('<meta name="'+name+'" content="'+value+'" />');
            }
        }
    }

    private getZones() {
        let els=$(this.selector).add('[data-zone]');
        if (els.find('[data-dplex-tainted]').length) return;

        let ael=document.activeElement;
        let activeEl=ael?$(ael):null;
        if (activeEl) activeEl.addClass('history-focus');
        let zones:Record<string,string>={};
        for (let el of els) {
            let e=$(el);
            let zone=e.data('zone')??'html';
            let html=(zone=='html')?e[0].innerHTML:e[0].outerHTML;
            zones[zone]=html;
        }
        if (activeEl) activeEl.removeClass('history-focus');
        return zones;
    }

    private getSelectorsFromZones(zones:string[]):string[] {
        if (!zones) return ['.dialog-off-canvas-main-canvas','[data-zone]'];
        let result=[];

        for (let zone of Object.keys(zones)) {
            if (zone=='html') {
                result.push('.dialog-off-canvas-main-canvas');
            } else {
                result.push('[data-zone="'+zone+'"]');
            }
        }

        return result;
    }

    //We scramble/randomize IDs in the leaving container before
    //we can call Drupal.attachBehaviors. The existence of
    //duplicate IDs confuses some of Drupal's behaviors (e.g. ajax forms).
    //We don't remove the IDs completely to be as compatible as
    //possible with existing styles matching on the ID.
    public scrambleIds(e:JQuery<HTMLElement>,zones:string|string[]=[]) {
        if (typeof zones=='string') zones=[zones];
        let selectors=this.getSelectorsFromZones(zones).join(',');

        e.find(selectors).addBack(selectors).find('[id]').each(
            (idx,e)=>{
                let ex=$(e);
                let id=ex.attr("id");
                ex.attr("id",id+'-'+this.getUUID());
            }
        );
    }

    private getOptionsFromTarget(target:JQuery<HTMLElement>):any {
        if (!target || !target.length) return {};
        let opts:any={};
        if (target.data('dplex-zones')) opts.zones=target.data('dplex-zones').split(' ');
        return opts;
    }

    public async navigate(url:string,info:any={}) {
        if (!url) {console.log('No URL specified.');return;}
        if ($(this.selector).hasClass('leaving')) return;
        var target=info.target;
        $('.history-trail').removeClass('history-trail');
        if (info.target) info.target.addClass('history-trail');
        if (!info.modal) this.cleanNonModals();
        if ($(this.selector).hasClass('modal')) {
            this.lastLocation=$(this.selector).data('location');
        }
        let navid=this.getUUID();
        this.navigationid=navid;
        var sel=$(this.selector);
        var zones=this.getZones();
        if (info.target) {
            info.target.closest('a').addClass('loading');
        }
        history.scrollRestoration='manual';
        var histargs={...info};
        delete histargs.target;
        if (!info.modal) {
            this.saveScrollPositionAndFocus();
            this.zonesMap[this.uniqid]=zones;
            history.replaceState({
                title: document.title,
                metatags: this.getMetatags(),
                settings: this.getSettings(),
                args: histargs,
                uniqid: this.uniqid,
                direction: 'next'
            },"");
            DPlex.location(url);
        }

        var opts=this.getOptionsFromTarget(info.target);
        if (info.post) opts.post=info.post;
        if (info.zones) opts.zones=info.zones;

        opts.returnOuterZones=true;
        let e=await DPlex.get([this.lastLocation,url],opts);

        if (navid!=this.navigationid) {
            console.log('Discarding outdated navigation response.');
            return;
        }
        var enter=this.prepareEnter(e.zones.html);
        this.uniqid++;
        var myargs={...info};
        delete myargs.target;
        var metadata:any=this.convertMetadata(e.metadata);
        if (!info.modal) {
            document.title=e.title;
            this.applyMetatags(e.metatags);
            history.pushState({
                title: e.title,
                metatags: e.metatags,
                settings: e.settings,
                args: myargs,
                direction: 'next',
                uniqid: this.uniqid
            },"",url+(myargs.hash??''));
            enter.find('a[rel="back"]').addClass('is-back').attr('href',this.lastLocation);
            this.lastLocation=url;
        } else {
            enter.addClass('modal');
            enter.data('location',url);
        }

        let imgs=enter.find('img[src]');
        imgs.removeAttr('loading');

        var leave=this.prepareLeave();
        this.lastModalLocation=info.modal?url:'';

       metadata.leave={
            ...metadata.leave,
            width: leave.width(),
            height: leave.height(),
            offset: leave.offset(),
            rect: leave[0].getBoundingClientRect()
        };

        enter.insertAfter(leave);
        //Remove class early to trigger CSS animations
        setTimeout(()=>{enter.removeClass('enter')},1);

        metadata.enter.focus=$('body');

        let appliedSettings=this.applySettings(e.settings);
        this.scrambleIds(leave,info.zones);
        Drupal.attachBehaviors(enter[0],appliedSettings);
        metadata.enter.scrollY=0;
        delete e.zones.html;
        delete info.zones;
        var args:DPlexArguments={
            zones: e.zones,
            leave,
            enter,
            metadata,
            target,
            modal: info.modal??false,
            direction:'next',
            info
        };

        if (args.target && args.targetX && args.targetY) {
            var rect=args.target[0].getBoundingClientRect();
            args.x=args.targetX+rect.left;
            args.y=args.targetY+rect.top;
        }

        $(document).trigger('nav',args);
    }

    public async reload() {
        var e=await DPlex.get(this.lastLocation,{returnOuterZones:true});
        var container=$(this.selector).not('.modal');
        container.html(e.zones.html);
        container.removeData();
        let appliedSettings=this.applySettings(e.settings);
        Drupal.attachBehaviors(container[0],appliedSettings);
    }

    public async reloadModal() {
        if (!this.lastModalLocation) return;
        var e=await DPlex.get(this.lastModalLocation,{returnOuterZones:true});
        var container=$(this.selector).filter((idx,e)=>$(e).data("location")===this.lastModalLocation);
        container.html(e.zones.html);
        container.removeData();
        let appliedSettings=this.applySettings(e.settings);
        Drupal.attachBehaviors(container[0],appliedSettings);
    }

    public refresh=(event:JQuery.TriggeredEvent)=>{
        this.close();
        this.reload();
    }

    public async close(args?:DPlexArguments) {
        if (!this.lastModalLocation) return;
        var leave=$(this.selector).filter((idx,e)=>$(e).data("location")===this.lastModalLocation);
        var enter=$(this.selector).not('.modal');
        var lastUrl=this.lastModalLocation;
        this.lastModalLocation='';
        let enterLocation=location.pathname+location.search;
        let md=await DPlex.metadata({leave:lastUrl,enter:enterLocation});
        let metadata:any=this.convertMetadata(md);

        args=Object.assign(args??{},{
            leave,
            enter,
            metadata,
            zones:{},
            direction:'close'
        });

        $(document).trigger('nav',args);
    }

    public click(event:JQuery.ClickEvent) {
        var target=$(event.target);
        var atag=target.closest('a');
        if (!atag.length) return;
        var href=this.getHRef(atag);
        if (!href) return;

        var hash='';
        var hashp=href.indexOf('#');
        if (hashp!=-1) {
            hash=href.substr(hashp);
            href=href.substr(0,hashp);
        }

        event.preventDefault();
        if (atag.hasClass('is-back')) {history.back();return;}
        var args:any={};
        var rect=target[0].getBoundingClientRect();
        args.targetX=event.clientX-rect.left;
        args.targetY=event.clientY-rect.top;
        args.target=target;
        args.hash=hash;
        if (atag.attr('target')=='_modal') args.modal=true;
        if (args.modal && this.lastModalLocation===href) {
            this.close(args);
            return;
        }
        this.navigate(href,args);
    }

}

JSEvents.setDefaultTarget('nav',document);

export {};